import { Box, chakra } from "@chakra-ui/react";
import React from "react";

import { route } from "nextjs/routes";

import { useMultichainContext } from "lib/contexts/multichain";
import getChainTooltipText from "lib/multichain/getChainTooltipText";
import getIconUrl from "lib/multichain/getIconUrl";
import * as EntityBase from "ui/shared/entities/base/components";

import { distributeEntityProps } from "../base/utils";

type LinkProps = EntityBase.LinkBaseProps &
  Partial<Pick<EntityProps, "hash" | "number">>;

const Link = chakra((props: LinkProps) => {
  const heightOrHash = props.hash ?? String(props.number);
  const defaultHref = route(
    {
      pathname: "/block/[height_or_hash]",
      query: { height_or_hash: heightOrHash },
    },
    props.chain ? { chain: props.chain } : undefined,
  );

  return (
    <EntityBase.Link {...props} href={props.href ?? defaultHref}>
      {props.children}
    </EntityBase.Link>
  );
});

const Icon = (props: EntityBase.IconBaseProps) => {
  return (
    <Box>
      <EntityBase.Icon
        {...props}
        name={props.name ?? "block_slim"}
        color="#18C900"
        // className="text-primary"
      />
    </Box>
  );
};

type ContentProps = Omit<EntityBase.ContentBaseProps, "text"> &
  Pick<EntityProps, "number">;

const Content = chakra((props: ContentProps) => {
  return (
    <EntityBase.Content
      {...props}
      text={String(props.number)}
      tailLength={props.tailLength ?? 2}
    />
  );
});

const Container = EntityBase.Container;

export interface EntityProps extends EntityBase.EntityBaseProps {
  number: number | string;
  hash?: string;
}

const BlockEntity = (props: EntityProps) => {
  const multichainContext = useMultichainContext();
  const partsProps = distributeEntityProps(props, multichainContext);

  const content = <Content {...partsProps.content} />;

  return (
    <Container {...partsProps.container}>
      <Icon {...partsProps.icon} />
      {props.noLink ? content : <Link {...partsProps.link}>{content}</Link>}
    </Container>
  );
};

export default React.memo(chakra(BlockEntity));

export { Container, Link, Icon, Content };
